/**
 * Lightbox store — leaf module. Controls the fullscreen image lightbox overlay
 * (image viewing, inline editor, optional inpainting + chat input).
 *
 * No api/socket/store-barrel imports — moved out of store/index.js (Perf 3.1.b).
 */
import { create } from 'zustand';

export const useLightboxStore = create((set) => ({
  // State
  isOpen: false,
  imageUrl: null,
  fileId: null,
  conversationId: null,
  openToEditor: false,
  dismissOnOutsidePress: true,
  withInpainting: false,
  withChatInput: false,
  chatInputProps: {},
  // Actions
  actions: {
    openLightbox: (options = {}) => {
      set({
        isOpen: true,
        imageUrl: options.imageUrl || null,
        fileId: options.fileId || null,
        conversationId: options.conversationId || null,
        openToEditor: !!options.openToEditor,
        dismissOnOutsidePress: !!options.dismissOnOutsidePress,
        withInpainting: options.withInpainting,
        withChatInput: !!options.withChatInput,
        chatInputProps: options.chatInputProps || {},
      });
    },
    closeLightbox: () => {
      set({
        isOpen: false,
        imageUrl: null,
        fileId: null,
        conversationId: null,
        openToEditor: false,
        dismissOnOutsidePress: true,
        withInpainting: false,
        withChatInput: false,
        chatInputProps: {},
      });
    },
  },
}));

export default useLightboxStore;
